import { get, put, del } from '../utils/makeRequest';

const SUBSCRIPTIONS_ENDPOINTS = {
  GET_ALL_SUBSCRIPTIONS: '/admin/subscriptions',
  GET_SUBSCRIPTION_STATS: '/admin/subscriptions/stats',
  GET_SUBSCRIPTION_DETAILS: '/admin/subscriptions',
  UPDATE_SUBSCRIPTION_STATUS: '/admin/subscriptions',
  DELETE_SUBSCRIPTION: '/admin/subscriptions',
};

export const subscriptionsService = {
  /**
   * Get all subscriptions with filtering and pagination
   * @param {Object} params - Query parameters
   * @returns {Promise} - List of subscriptions with pagination
   */
  getAllSubscriptions: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = `${SUBSCRIPTIONS_ENDPOINTS.GET_ALL_SUBSCRIPTIONS}${queryParams ? `?${queryParams}` : ''}`;
    return get(url);
  },

  /**
   * Get subscription statistics
   * @returns {Promise} - Subscription statistics and plan data
   */
  getSubscriptionStats: async () => {
    return get(SUBSCRIPTIONS_ENDPOINTS.GET_SUBSCRIPTION_STATS);
  },

  /**
   * Get subscription details by ID
   * @param {number} id - Subscription ID
   * @returns {Promise} - Subscription details
   */
  getSubscriptionDetails: async (id) => {
    return get(`${SUBSCRIPTIONS_ENDPOINTS.GET_SUBSCRIPTION_DETAILS}/${id}`);
  },

  /**
   * Update subscription status
   * @param {number} id - Subscription ID
   * @param {string} status - New status
   * @param {string} reason - Reason for status change
   * @returns {Promise} - Update result
   */
  updateSubscriptionStatus: async (id, status, reason = '') => {
    return put(`${SUBSCRIPTIONS_ENDPOINTS.UPDATE_SUBSCRIPTION_STATUS}/${id}/status`, {
      status,
      reason
    });
  },

  deleteSubscription: async (id) => {
    return del(`${SUBSCRIPTIONS_ENDPOINTS.DELETE_SUBSCRIPTION}/${id}`);
  },
};
